export default {
  back: "Back",
  connect: "Connect",
  connectWallet: "Connect wallet",
  error: "Error",
  migration: "Token Update",
  view: "View",
  wallet: "Wallet",
  disconnect: "Disconnect",
  transactions: {
    title: "Transactions",
    errorMessage: "The transaction could not be completed. Check the address or the balance of available tokens.",
    seeTransaction: "See transaction",
    types: {
      APPROVE: "Approve",
      MIGRATE: "Update",
    },
    status: {
      PENDING: "Pending",
      SUCCESS: "Success",
      REVERTED: "Reverted",
    },
  },
  signature: {
    title: "Signature",
    errorMessage: "The signature could not be completed.",
    status: {
      PENDING: "Pending",
      SUCCESS: "Success",
      REVERTED: "Reverted",
    },
  },
}
